export default __webpack_public_path__ + "static/media/landing-page-img.b951fdb6.png";